"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@commerce-ui/core2");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RadioRaw = _interopRequireDefault(require("@commerce-ui/core2/RadioRaw"));
var _excluded = ["disabled", "highlighted", "selected", "label", "invalid", "sx", "as", "children", "onFocus", "onBlur", "onSelect", "ignoreLabel", "id", "containerAdditionalStyles"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  ignoreLabel: false
};
var Selectable$ = function Selectable$(props) {
  var disabled = props.disabled,
    highlighted = props.highlighted,
    selected = props.selected,
    label = props.label,
    invalid = props.invalid,
    sx = props.sx,
    as = props.as,
    children = props.children,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    onSelect = props.onSelect,
    _props$ignoreLabel = props.ignoreLabel,
    ignoreLabel = _props$ignoreLabel === void 0 ? defaultProps.ignoreLabel : _props$ignoreLabel,
    id = props.id,
    containerAdditionalStyles = props.containerAdditionalStyles,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(false),
    focused = _useState[0],
    setFocused = _useState[1];
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
    css = _splitSx2[0],
    customSx = _splitSx2[1];
  if (!label && ignoreLabel === false) {
    console.warn("You didn't pass label prop to the Selectable. This will affect accessibility negatively.");
  }
  var state = _objectSpread({}, props);
  var content = children(state);
  var radioRef = (0, _react.useRef)(null);
  if (as === "link") {
    return __jsx(_LinkRaw["default"], (0, _extends2["default"])({
      title: label,
      sx: _objectSpread({
        $resetFocus: true,
        display: "block"
      }, css),
      onFocus: function onFocus(e) {
        setFocused(true);
        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);
        if (_onBlur) {
          _onBlur(e);
        }
      },
      id: id
    }, restProps), content);
  }
  if (as === "radio") {
    return __jsx(_Box["default"], {
      sx: _objectSpread({
        display: "block",
        position: "relative",
        cursor: "pointer"
      }, css),
      onClick: function onClick() {
        if (disabled) {
          return;
        }
        radioRef.current.focus();
        if (onSelect) {
          onSelect();
        }
      },
      className: focused ? "__commui_focus" : ""
    }, __jsx("label", {
      htmlFor: id,
      sx: {
        visibility: "hidden",
        position: "absolute"
      }
    }, label), __jsx(_RadioRaw["default"], (0, _extends2["default"])({}, restProps, {
      id: id,
      onFocus: function onFocus(e) {
        setFocused(true);
        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);
        if (_onBlur) {
          _onBlur(e);
        }
      },
      checked: selected,
      disabled: disabled,
      onChange: function onChange() {
        if (onSelect) {
          onSelect();
        }
      },
      inputRef: radioRef
    })), content);
  }
  return __jsx(_Box["default"], (0, _extends2["default"])({
    sx: _objectSpread(_objectSpread({}, containerAdditionalStyles), {}, {
      cursor: disabled ? "not-allowed" : "pointer"
    })
  }, restProps), content);
};
var _default = Selectable$;
exports["default"] = _default;